import React from 'react';
import { Typography } from '@mui/material';
import CustomizedDialogs from '../../../components/Modal';
import { PricebookBundle } from '../../../models/PricebookData';

interface RevertToInheritedModalProps {
  onClose: () => void;
  pricebook: PricebookBundle | null;
  parentTierName: string;
  onConfirm: (pricebook: PricebookBundle) => void;
}

const RevertToInheritedModal: React.FC<RevertToInheritedModalProps> = ({
  onClose,
  pricebook,
  parentTierName,
  onConfirm,
}) => {
  if (!pricebook) return null;

  return (
    <CustomizedDialogs
      open={true}
      className='rev-share-confirmation'
      title={`Inherit from ${parentTierName.toLowerCase()}?`}
      primaryButtonText='Inherit'
      secondaryButtonText='Cancel'
      handleSave={() => onConfirm(pricebook)}
      handleCancel={onClose}
      onClose={onClose}>
      <Typography variant='p16' color='secondary.main'>
        All custom entries for this pricebook will be removed. This cannot be undone.
      </Typography>
    </CustomizedDialogs>
  );
};

export default RevertToInheritedModal;
